import {KTSVG} from '../../../_metronic/helpers'
import React, {FC, useEffect, useState, useRef, forwardRef, useImperativeHandle, SetStateAction, Dispatch} from 'react'
import {Modal} from 'react-bootstrap'
import Select from 'react-select'
import {Column} from 'react-table'
import {useMutation, useQueryClient} from 'react-query'
import {Mainsubtable2} from '../../tables/Mainsubtable2'
import {useAuth} from '../../../app/modules/auth'
import {useMemo} from 'react'
import { useAddsalesinvoices } from '../../contextProviders/Atomqueryprovider'
import {useReactToPrint} from 'react-to-print'
import { useAllproductsandtypes,useAllpaymenttypes, useAllcustomers} from '../../contextProviders/Atomqueryprovider'
import {Printingsalesinvoice} from '../../printing/Printingsalesinvoice'
import {useWindowWidth} from '@react-hook/window-size/throttled'
import io from 'socket.io-client'
import { useSelectStyles } from '../../helpers/useSelectStyles'
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone'


dayjs.extend(utc);
dayjs.extend(timezone);



type Props = {
  show: boolean
  handleClose: () => void
  ref: any
  frequentsaleDetails: any
  frequentsaledoubleentry: any
  setFrequentsaleDetails: Dispatch<SetStateAction<any| undefined>>
  setFrequentsaledoubleentry : Dispatch<SetStateAction<any| undefined>>
}
const socket = io('possocket.27mirrors.com')
const uuidTime = () => {
  return new Date().valueOf()
}
const CURRENCY_APP = process.env.REACT_APP_CURRENCY
const SALES_TAX_MADE = process.env.REACT_APP_SALES_TAX

const truncate = require('truncate')
const addCommas = (num: any) => {
  // Handle undefined, null, or non-numeric values
  if (num === undefined || num === null || num === '') {
    return '0'
  }
  
  // Convert to number if it's a string
  const numValue = typeof num === 'string' ? parseFloat(num) : num
  
  // Check if it's a valid number
  if (isNaN(numValue)) {
    return '0'
  }
  
  return numValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}
function isNegative(num: any) {
  if (Math.sign(num) === -1) {
    return true
  }
  return false
}

export const Addorder: FC<Props> = forwardRef((props, ref) => {
  const selectRef = useRef<any | null>(null)
  

  const componenttoprint= useRef<any | null>(null)

  const [submit_invoice, setSubmit_Invoice] = useState(false)
  const [products, setProducts] = useState<any>([])

  const [payment_type_id, setPayment_type_id] = useState<number>(1)


  const [product_name, setProduct_name] = useState('')
  const [invoiceid, setInvoiceid] = useState<any>('')
  const [units_in_stock, setUnits_in_stock] = useState<number>(0)
  const [unit_buying_price, setUnit_buying_price] = useState<number>(0)
  const [discount, setDiscount] = useState<number>(0)
  const [sales_tax, setSales_tax] = useState<number>(0)

  const [product_unit_id, setProduct_unit_id] = useState<number>(0)
  const [product_id, setProduct_id] = useState<number>(0)
  const [unit_selling_price, setUnit_selling_price] = useState<number>(0)
  const [product_division, setProduct_division] = useState<number>(0)
  const onlyWidth = useWindowWidth()
  const [category_name, setCategory_name] = useState<string>('')
  const [unit_name, setUnit_name] = useState<string>('')
  const [product_category_id, setProduct_category_id] = useState('')
  const [currentItemsmade, setCurrentItemsmade] = useState<any>([])
  const [addeditemsLoaded, setAddeditemsLoaded] = useState(true)
  const [newSetquantity, setNewSetquantity] = useState<number>(0)
  const [newSetprice, setNewSetprice] = useState<number>(0)
  const {currentUser, logout} = useAuth()
   const [finishedupdate,setFinishedupdate]= useState(false);
   const [finishedupdate2,setFinishedupdate2]= useState(false);
  //customer id and payment type
  const [customer_id, setCustomer_id] = useState<number>(1)
  const [paymentoptions, setPaymentoptions] = useState<any>([])
  const [customeroptions, setCustomeroptions] = useState<any>([])
  const addCommas = (num: any) => {
  // Handle undefined, null, or non-numeric values
  if (num === undefined || num === null || num === '') {
    return '0'
  }
  
  // Convert to number if it's a string
  const numValue = typeof num === 'string' ? parseFloat(num) : num
  
  // Check if it's a valid number
  if (isNaN(numValue)) {
    return '0'
  }
  
  return numValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

  const [allsubtotalsmade, setAllsubtotalsmade] = useState<number>(0)
  const queryClient = useQueryClient()

  
  const {
    isLoading: allproductsandtypesloading,
    isSuccess: allproductsandtypessuccess,
    data: allproductsandtypesdata,
    status: allproductsandtypesstatus,
    refetch: allproductsandtypesrefetch
  } = useAllproductsandtypes()

  const {
    isLoading:  allpaymenttypesloading,
    isSuccess:  allpaymenttypessuccess,
    data:  allpaymenttypesdata,
    status:allpaymenttypesstatus
  
  } = useAllpaymenttypes()


 const {
    isLoading: allcustomersloading,
    isSuccess: allcustomerssuccess,
    data: allcustomersdata,
   status: allcustomersstatus
   
  } = useAllcustomers()

  socket.on('update', (arg) => {
   
    allproductsandtypesrefetch();
   
  });

  const RoundNearstep = function (number: number) {
    return Number(
      Math.round(number * (1 / Number(product_division))) / (1 / Number(product_division))
    )
  }


  const columnaddedtitems: ReadonlyArray<
    Column<{
      product_name: string
      quantity: number
      unit_price: number
      sub_total: number
    }>
  > = [
    {
      Header: 'Name',
      accessor: 'product_name',

      Cell: ({cell: {value}, row}) => (
        <>
          <span className='text-dark text-nowrap  fw-bolder d-block mb-1 fs-6'>
            {truncate(value, 20)}
          </span>
        </>
      ),
    },
    {
      Header: 'Quantity',
      accessor: 'quantity',

      Cell: ({cell: {value}, row}) => (
        <>
          <span className='text-dark text-nowrap  fw-bolder d-block mb-1 fs-6'>{value}</span>
        </>
      ),
    },
    {
      Header: 'Price',
      accessor: 'unit_price',

      Cell: ({cell: {value}, row}) => (
        <>
          <span className='text-dark text-nowrap  fw-bolder d-block mb-1 fs-6'>
            {addCommas(Number(value).toFixed(2))} {CURRENCY_APP}
          </span>
        </>
      ),
    },
    {
      Header: 'Total',
      accessor: 'sub_total',

      Cell: ({cell: {value}, row}) => (
        <>
          <span className='text-dark text-nowrap  fw-bolder d-block mb-1 fs-6'>
            {addCommas(Number(value).toFixed(2))} {CURRENCY_APP}
          </span>
        </>
      ),
    },
    {
      Header: () => null,
      id: 'expander',

      Cell: ({row}: any) => {
        return (
          <div className='d-flex justify-content-end flex-shrink-0'>
            <a
              href='#'
              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm border'
              onClick={() => handleRemoveItem(row.index)}
            >
              {/*begin::Svg Icon | path: icons/duotune/general/gen027.svg*/}
              <span className='svg-icon svg-icon-3'>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width={24}
                  height={24}
                  viewBox='0 0 24 24'
                  fill='none'
                >
                  <path
                    d='M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z'
                    fill='#f1416c'
                  />
                  <path
                    opacity='0.5'
                    d='M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z'
                    fill='#f1416c'
                  />
                  <path
                    opacity='0.5'
                    d='M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z'
                    fill='#f1416c'
                  />
                </svg>
              </span>
              {/*end::Svg Icon*/}
            </a>
          </div>
        )
      },
    },
  ]

  const columnaddedtitems2: ReadonlyArray<
    Column<{
      product_name: string
      quantity: number
      unit_price: number
      sub_total: number
    }>
  > = [
    {
      Header: 'Name',
      accessor: 'product_name',

      Cell: ({cell: {value}, row}) => (
        <>
          <span className='text-dark text-nowrap  fw-bolder d-block mb-1 fs-6'>
            <span>{truncate(value, 20)}</span>
            <span className='h-20px border-gray-200 border-start mx-2'></span>
            <span>{row.original.quantity}</span>
          </span>
          <span className='text-muted text-nowrap d-block mb-1 fs-6'>
            {addCommas(row.original.sub_total.toFixed(2))} {CURRENCY_APP}
          </span>
        </>
      ),
    },

    {
      Header: () => null,
      id: 'expander',

      Cell: ({row}: any) => {
        return (
          <div className='d-flex justify-content-end flex-shrink-0'>
            <a
              href='#'
              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm border'
              onClick={() => handleRemoveItem(row.index)}
            >
              {/*begin::Svg Icon | path: icons/duotune/general/gen027.svg*/}
              <span className='svg-icon svg-icon-3'>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width={24}
                  height={24}
                  viewBox='0 0 24 24'
                  fill='none'
                >
                  <path
                    d='M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z'
                    fill='#f1416c'
                  />
                  <path
                    opacity='0.5'
                    d='M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z'
                    fill='#f1416c'
                  />
                  <path
                    opacity='0.5'
                    d='M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z'
                    fill='#f1416c'
                  />
                </svg>
              </span>
              {/*end::Svg Icon*/}
            </a>
          </div>
        )
      },
    },
  ]
  const adddatatable = useMemo(() => currentItemsmade, [currentItemsmade])




  useEffect(() => {
    if (currentItemsmade.length > 0) {
      setAddeditemsLoaded(false)
    } else {
      setAddeditemsLoaded(true)
    }
    let allsubtotals: number = 0
    currentItemsmade.forEach((a: any) => (allsubtotals += parseFloat(a.sub_total)))

    setAllsubtotalsmade(allsubtotals)
  }, [currentItemsmade])

  useImperativeHandle(ref, () => ({
    Resetmodalvalues2() {
      setSubmit_Invoice(false)
      setCurrentItemsmade([])
      setInvoiceid(uuidTime)
      setUnits_in_stock(0)
      setUnit_buying_price(0)
      setProduct_unit_id(0)
      setProduct_id(0)
      setUnit_selling_price(0)
      setNewSetquantity(0)
      setNewSetprice(0)
      setUnit_name("")
      setFinishedupdate(false)
      setFinishedupdate2(false)
      setProduct_name("")
      setSales_tax(0)
      setDiscount(0)

      // props.setIsopenedModal(true)
    },
    Resetmodalvalues3() {
    
      setFinishedupdate(false)
      setFinishedupdate2(false)
    
      // props.setIsopenedModal(true)
    },
    Resetmodalvalues4() {

      submitInvoice()
    }
   
  }))



  

  const handlePrint = useReactToPrint({
    content: () => componenttoprint.current,
  })



  useEffect(() => {
    if (newSetquantity >= 0) {
      setNewSetprice(((Number(unit_selling_price) * Number(newSetquantity))- (discount * Number(newSetquantity))) + (sales_tax * Number(newSetquantity)))
    }
    if (newSetquantity > units_in_stock) {
      setNewSetquantity(units_in_stock)
      setNewSetprice(((Number(unit_selling_price) * Number(units_in_stock))- (discount * Number(units_in_stock))) + (sales_tax * Number(units_in_stock)))
    
    }
  }, [newSetquantity])


  useEffect(() => {

    if(allproductsandtypessuccess){
   
      setProducts(
      allproductsandtypesdata?.data
          .sort((a: any, b: any) => (a.product_name > b.product_name ? 1 : -1)).map((val: any, index: any) => {
            return {
              value: val.product_name,
              label: (
                <span>
                  {val.product_name}
                  {" "}<span className= { val.units_in_stock > 0 ? "text-success" : "text-danger" }>
                    ({val.units_in_stock})
                  </span>
                </span>
              ),
              units_in_stock: val.units_in_stock,
              unit_buying_price: val.unit_buying_price,
              product_category_id: val.product_category_id,
              product_unit_id: val.product_unit_id,
              product_id: val.product_id,
              unit_selling_price: val.unit_selling_price,
              product_division: val.product_division,
              category_name: val.category_name,
              unit_name: val.unit_name,
              discount_percentage: val.discount_percentage,
              sales_tax: Number(SALES_TAX_MADE)


            }
          })
        
      )
      
    }

    
  }, [allproductsandtypessuccess, invoiceid])

  const addNewitemsTable = () => {
    const addeditemsintable = {
      units_in_stock: Number(units_in_stock - newSetquantity),
      sub_total: newSetprice,
      unit_price: Number(unit_selling_price),
      quantity: Number(newSetquantity),
      product_name: product_name,
      product_id: product_id,
      user_id: currentUser?.user_id,
      sales_invoice_id: invoiceid,
      product_unit_id: product_unit_id,
      discount: discount,
      sales_tax: sales_tax

    }
    
   

    setProducts(
      products.map((x: any) =>
        x.product_id == product_id ? {...x, units_in_stock: units_in_stock - newSetquantity} : x
      )
    )


    setCurrentItemsmade([...currentItemsmade, addeditemsintable])
  }

  const removeNewitemsTable = (e: any) => {
    
    setNewSetquantity(0)
    setCurrentItemsmade([])
    setProducts(
      allproductsandtypesdata?.data
         
          .sort((a: any, b: any) => (a.product_name > b.product_name ? 1 : -1)).map((val: any, index: any) => {
            return {
              value: val.product_name,
              label: val.product_name,
              units_in_stock: val.units_in_stock,
              unit_buying_price: val.unit_buying_price,
              product_category_id: val.product_category_id,
              product_unit_id: val.product_unit_id,
              product_id: val.product_id,
              unit_selling_price: val.unit_selling_price,
              product_division: val.product_division,
              category_name: val.category_name,
              unit_name: val.unit_name,
              discount_percentage: val.discount_percentage,
              sales_tax: Number(SALES_TAX_MADE)
            }
          })
        
      )


  }
  const handlequantitychange = (e: any) => {
    setNewSetquantity(RoundNearstep(Number(e.target.value)))
  }

  const handlepricechange = (e: any) => {
    setNewSetprice(e.target.value)
  }
 
  //delete item
  const handleRemoveItem = (e: number) => {
    setProducts(
      products.map((x: any) =>
        x.product_id == currentItemsmade[e].product_id
          ? {
              ...x,
              units_in_stock: currentItemsmade[e].units_in_stock + currentItemsmade[e].quantity,
            }
          : x
      )
    )

    setCurrentItemsmade((currentItemsmade: any) => {
      return currentItemsmade.filter((value: any, i: number) => i !== e)
    })
  }

 


  const allsalesadded: any = [{

    currentuser: Number(currentUser?.user_id),
    invoiceid: invoiceid,
    allsubtotalsmade: allsubtotalsmade,
    currentItemsmade: currentItemsmade.map((x:any)=>{return{
      quantity: x.quantity, 
      unit_price: x.unit_price, 
      sub_total: x.sub_total, 
      product_id: x.product_id, 
      user_id: x.user_id, 
      sales_invoice_id: x.sales_invoice_id, 
      datesold: dayjs(new Date()).tz('Africa/Nairobi').format('YYYY-MM-DD HH:mm:ss'), 
      sales_status: "NOT PAID",
      discount: x.discount,
      sales_tax: x.sales_tax

    }}),
    amount_tendered: allsubtotalsmade,
    payment_type_id: payment_type_id,
    customer_id:customer_id,
    dateinvoicemade: dayjs(new Date()).tz('Africa/Nairobi').format('YYYY-MM-DD HH:mm:ss')

  }]


  const {mutateAsync: addsalesinvoicemutateAsync} =  useAddsalesinvoices(allsalesadded)

  const submitInvoice = async () => {

    addsalesinvoicemutateAsync(allsalesadded , {
      onSuccess: () =>{
        setSubmit_Invoice(false)
    props.handleClose()

      },
      onError(error, variables, context) {
        console.log(error)
        setSubmit_Invoice(true)
        props.handleClose()
      },

    })
   
}



  const handlepaymentChange = (e: any) => {
    if (e != null) {
      setPayment_type_id(e.value)
    }
  }

  const handlecustomerChange = (e: any) => {
    if (e != null) {
      setCustomer_id(e.value)
    }
  }

 
  const handleproductChange = (e: any) => {
 
    
    if (e != null) {
      setNewSetquantity(0)
      setNewSetprice(0)
      setUnits_in_stock(e.units_in_stock)
      setUnit_buying_price(e.unit_buying_price)
      setProduct_category_id(e.product_category_id)
      setProduct_unit_id(e.product_unit_id)
      setProduct_id(e.product_id)
      setUnit_selling_price(e.unit_selling_price)
      setProduct_name(e.label)
      setProduct_division(e.product_division)
      setCategory_name(e.category_name)
      setUnit_name(e.unit_name)
      setSales_tax(e.sales_tax * e.unit_selling_price)
      setDiscount((e.discount_percentage * 0.01) * e.unit_selling_price)


    }

    
  }

  useEffect(()=>{
    if(allcustomerssuccess){
     setCustomeroptions (allcustomersdata?.data.map((val: any, index: any) => {
        return {
          value: val.customer_id,
          label: val.customer_firstname + ' ' + val.customer_secondname,
        }
      }))
    }
      
    },[allcustomerssuccess, invoiceid])
  
    useEffect(()=>{
    if(allpaymenttypessuccess){
  
      setPaymentoptions(
        allpaymenttypesdata?.data.map((val: any, index: any) => {
          return {
            value: val.payment_type_id,
            label: val.payment_type_name,
          }
        })
      )
    }
  
  
    },[allpaymenttypessuccess, invoiceid])


  useEffect(() => {

    if(selectRef.current && products.length > 0 && props.frequentsaleDetails){
     
      ;(async () => {
       selectRef.current.setValue(products.find((x:any)=>x.value === props.frequentsaleDetails.product_name));
       setNewSetquantity(props.frequentsaleDetails.quantity)
      })()

      setFinishedupdate(true);
      props.setFrequentsaledoubleentry(false)
    

    }
    if(selectRef.current && products.length > 0 && !props.frequentsaleDetails){
     
      ;(async () => {
      selectRef.current.select.clearValue();
       setNewSetquantity(0)
      })()

      setFinishedupdate(true);
      props.setFrequentsaledoubleentry(false)
    

    }
  }, [props.frequentsaleDetails, invoiceid, props.frequentsaledoubleentry])



  useEffect(() => {

    if(finishedupdate && unit_selling_price > 0 && props.frequentsaleDetails.quantity){
      ;(async () => {

        setNewSetprice(((Number(unit_selling_price) * Number(props.frequentsaleDetails.quantity))- (discount * Number(props.frequentsaleDetails.quantity))) + (sales_tax * Number(props.frequentsaleDetails.quantity))) 
    
    })()
    setFinishedupdate2(true);
      
    }

  }, [finishedupdate, unit_selling_price])


  useEffect(() => {

    if(finishedupdate && unit_selling_price > 0 && props.frequentsaleDetails.quantity && units_in_stock > 0){
  
    addNewitemsTable()
      
    }

  }, [finishedupdate2])

 


  useEffect(()=>{
    if(products.length > 0){
      products.map((val: any, index: any) => {
      
     
        if (val.product_id === product_id) {
         
          setUnits_in_stock(val.units_in_stock)
        }
      })
    }
      
    },[products])


  return (
    <Modal
      className='modal fade'
      id='kt_modal_dashboard'
      data-backdrop='static'
      tabIndex={-1}
      role='dialog'
      show={props.show}
      centered
      dialogClassName='modal-lg'
      aria-hidden='true'
      onHide={props.handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h3 className='fw-bolder'>Add Order</h3>
     
          <div
            className='btn btn-icon btn-sm btn-active-light-primary ms-2'
            onClick={props.handleClose}
          >
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          <div className='fv-row fw-bold fs-7 text-gray-400 mb-7'>
            Order No <span className='h-20px border-gray-300 border-start mx-4'></span>{' '}
            {invoiceid}
          </div>
          <form className='form' noValidate>
            {/* begin::Input group */}
            <div className='fv-row mb-7'>
              {/* begin::Label */}
              <label className='required fw-bold fs-6 mb-2'>Select Product</label>
              {/* end::Label */}

           
              <Select
                options={products}
                styles={useSelectStyles()}
                isDisabled={false}
                isLoading={allproductsandtypesloading}
                isSearchable={true}
                ref={selectRef}
                placeholder={"Select product ..."}
                //defaultValue={{value: props.frequentsaleDetails.product_name , label: props.frequentsaleDetails.product_name}}
                onChange={(e: any) => handleproductChange(e)}
              />
            </div>
            {/* end::Input group */}

            {/* begin::Input group */}
            {/* begin::Label */}
            <label className='required fw-bold fs-6 mb-2'>Product Details</label>

            {/* end::Label */}
            <div className='row'>
              <div className='col-lg-6 fv-row mb-7'>
                <div className='border border-gray-300 border-dashed rounded py-2 px-3'>
                  <div className='d-flex align-items-center'>
                    <div className='fs-4 fw-bolder'>
                      {addCommas(units_in_stock)}{' '}
                      {unit_name}
                    </div>
                  </div>

                  <div className='fw-bold fs-7 text-gray-400'>Stock Left</div>
                </div>
              </div>

              <div className='col-lg-6 fv-row mb-7'>
                <div className='border border-gray-300 border-dashed rounded py-2 px-3'>
                  <div className='d-flex align-items-center'>
                    <div className='fs-4 fw-bolder'>
                      {addCommas(unit_buying_price.toFixed(2))} {CURRENCY_APP}
                    </div>
                  </div>

                  <div className='fw-bold fs-7 text-gray-400'>Buying Price</div>
                </div>
              </div>
            </div>

            {/* end::Input group */}

            {/* begin::Input group */}
            <div className='row'>
              {/* begin::Label */}
              <label className='required fw-bold fs-6 mb-2'>
                Quantity ({unit_name})
              </label>
              {/* end::Label */}

              <div className='col-lg-6 fv-row mb-3'>
                <input
                  placeholder='0'
                  className='form-control form-control-lg form-control-solid'
                  type='number'
                  min='0'
                  step={`${product_division}`}
                  max={`${units_in_stock}`}
                  autoComplete='off'
                  value={Number(newSetquantity)}
                  disabled={units_in_stock > 0 ? false : true}
                  onChange={(e) => handlequantitychange(e)}
                />
              </div>
              <div className='col-lg-6 fv-row mb-7'>
                <div className='align-items-center justify-content-start form-control-sm'>
                  <a
                    onClick={() => {
                      setNewSetquantity((quant: number) => quant - product_division)
                    }}
                    style={{cursor: 'pointer'}}
                    className={
                      Number(newSetquantity) - product_division >= 0 && product_name != ''
                        ? ''
                        : 'pe-none'
                    }
                  >
                    <KTSVG
                      path='/media/icons/duotune/arrows/arr014.svg'
                      className={
                        Number(newSetquantity) - product_division >= 0 && product_name != ''
                          ? 'svg-icon-2x text-danger'
                          : 'svg-icon-2x'
                      }
                    />
                  </a>
                  <span className='h-20px border-gray-200 border-start mx-1'></span>
                  <a
                    onClick={() => {
                      setNewSetquantity((quant: number) => quant + product_division)
                    }}
                    style={{cursor: 'pointer'}}
                    className={
                      Number(newSetquantity) + product_division <= units_in_stock &&
                      product_name != ''
                        ? ''
                        : 'pe-none'
                    }
                  >
                    <KTSVG
                      path='/media/icons/duotune/arrows/arr013.svg'
                      className={
                        Number(newSetquantity) + product_division <= units_in_stock &&
                        product_name != ''
                          ? 'svg-icon-2x text-success'
                          : 'svg-icon-2x'
                      }
                    />
                  </a>
                </div>
              </div>
            </div>
            {/* end::Input group */}

            {/* begin::Input group */}
            <div className='row'>
              {/* begin::Label */}
              <label className='required fw-bold fs-6 mb-2'>Total Price ({CURRENCY_APP})</label>
              {/* end::Label */}

              <div className='col-lg-6 fv-row mb-3'>
                <input
                  disabled={true}
                  placeholder='0.00'
                  className='form-control form-control-lg form-control-solid'
                  type='number'
                  autoComplete='off'
                  value={parseFloat(newSetprice.toString()).toFixed(2)}
                  onChange={(e) => handlepricechange(e)}
                  
                />
              </div>
              <div className='col-lg-6 fv-row mb-7'>
                
              </div>
            </div>
            {/* end::Input group */}

            {/* begin::Input group */}
            <div className='fv-row mb-7'>
              <div className='d-flex flex-column flex-grow-1'>
                <div className='d-flex flex-wrap justify-content-end col-12'>
                  <button
                    type='button'
                    className='btn btn-light-danger me-2 mb-2'
                    disabled={addeditemsLoaded}
                    onClick={removeNewitemsTable}
                  >
                    Remove All Items
                  </button>

                  <button
                    type='button'
                    className='btn btn-primary mb-2'
                    onClick={addNewitemsTable}
                    disabled={
                      newSetquantity > 0 && newSetprice > 0 && newSetquantity <= units_in_stock
                        ? false
                        : true
                    }
                  >
                    Add Item
                  </button>
                </div>
              </div>
            </div>
            {/* end::Input group */}

            {/* begin::Input group */}
            <div className='fv-row mb-7'>
              <div className='card bg-light'>
                {/* begin::Header */}
                <div className='card-header border-0 pt-5'>
                  <h3 className='card-title align-items-start flex-column'>
                    <span className='required card-label fw-bolder fs-3 mb-1'>Added Items</span>
                    <span className='text-muted mt-1 fw-bold fs-7'>
                    `${Number(currentItemsmade.length)} ${Number(currentItemsmade.length) === 1 ? 'entry' : 'entries'} made`

                    </span>
                  </h3>
                  <div className='card-toolbar'>
                    {/* begin::Menu */}
                    <button
                      type='button'
                      className='btn btn-sm btn-icon btn-color-primary btn-active-light-primary border'
                      data-kt-menu-trigger='click'
                      data-kt-menu-placement='bottom-end'
                      data-kt-menu-flip='top-end'
                      disabled={addeditemsLoaded}
                      onClick={handlePrint}
                    >
                      <KTSVG
                        path='/media/icons/duotune/technology/teh011.svg'
                        className='svg-icon-2'
                      />
                    </button>
                  </div>
                </div>
                {/* end::Header */}
                {/* begin::Body */}
                <div className='card-body py-3'>
                  <div className='row'>
                    <div className='col-lg-6 fv-row mb-7'>
                      <label className='required fw-bold fs-6 mb-2'>Payment Mode</label>
                      <Select
                        options={paymentoptions}
                        styles={useSelectStyles()}
                        isDisabled={false}
                        isLoading={allpaymenttypesloading}
                        isSearchable={true}
                        placeholder={"Select payment mode ..."}
                        defaultValue={{label: 'MPESA', value: 1}}
                        onChange={(e: any) => handlepaymentChange(e)}
                      />
                    </div>

                    <div className='col-lg-6 fv-row mb-7'>
                      <label className='required fw-bold fs-6 mb-2'>Customer</label>
                      <Select
                        options={customeroptions}
                        styles={useSelectStyles()}
                        isDisabled={false}
                        isLoading={allcustomersloading}
                        defaultValue={{label: 'default default', value: 1}}
                        isSearchable={true}
                        placeholder={"Select customer ..."}
                        onChange={(e: any) => handlecustomerChange(e)}
                      />
                    </div>
                  </div>
                
                  {/* begin::Table container */}
                  <div className='table-responsive'>
                    {/* begin::Table */}

                    <Mainsubtable2
                      columnaddedtitems={
                        onlyWidth > 500 ? columnaddedtitems : columnaddedtitems2
                      }
                      adddatatable={adddatatable}
                    />

                    {/* end::Table */}
                    <div className='fv-row  mt-5 mb-5'>
                      <div className='d-flex flex-column flex-grow-1'>
                        <div className='d-flex justify-content-end'>
                          <div>
                            <div>
                              <div className='border-top border-bottom border-dark py-3'>
                              <span className='fs-5 fw-bolder me-2 mt-3'>
                              <span className='me-3'> Total:</span>
                                <span className='text-primary'>
                                  {addCommas(allsubtotalsmade.toFixed(2))} {CURRENCY_APP}
                                </span>
                              </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* end::Table container */}
                </div>
                {/* begin::Body */}
              </div>
            </div>
            {/* end::Input group */}
          </form>
        </div>
        <div className='modal-footer border-0 mt-n5'>
          <button type='button' className='btn btn-light-primary' onClick={props.handleClose}>
            Cancel
          </button>
          <button
            id='submit'
            type='button'
            className='btn btn-success'
            onClick={submitInvoice}
            disabled={addeditemsLoaded || submit_invoice}
          >
            {!submit_invoice && <span className='indicator-label'>Submit Invoice</span>}
            {submit_invoice && (
              <span className='indicator-progress' style={{display: 'block'}}>
                Please wait...
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
        </div>
      </div>

      <Printingsalesinvoice
        ref={componenttoprint}
        invoiceid={invoiceid}
        itemsaddeddate={currentItemsmade}
        adddatatable ={adddatatable}
      />
    </Modal>
  )
})


